<div class="back-header">
  <div class="back-icon" (click)="backToDashboard()">
    <i class="dx-icon dx-icon-chevronleft"></i>
  </div>
  <div class="back-text">
    {{ 'PROFILE.TITLE' | translate }}
  </div>
</div>

<!-- Profile Image Section -->
<div class="separate-input-field profile-image-section">
  <div class="profile-image-wrapper">
    <img
      [src]="profileImageUrl || 'assets/icons/imgpreview.png'"
      class="profile-image"
      alt="Profile" />
  </div>

  <dx-button
    [text]="'PROFILE.UPLOAD_IMAGE' | translate"
    type="default"
    stylingMode="contained"
    [elementAttr]="{ class: 'save-button upload-image-btn' }"
    (click)="triggerImageUpload()">
  </dx-button>

  <input
    type="file"
    accept="image/*"
    hidden
    #fileInput
    (change)="onImageSelected($event)" />
</div>

<div class="input-grid" *ngFor="let data of LoginUserProfileData">

<!-- Row 1 : Prefix + First Name + First Name Marathi -->
<dx-box
  direction="row"
  width="100%"
  [align]="'space-between'"
  [crossAlign]="'center'"
  style="margin-top: 0.5rem;">

  <ng-container *ngIf="isMarathi(); else englishFirstName">

    <!-- Marathi First -->
    <dxi-item [ratio]="6" class="separate-input-field">

      <div style="display:flex; gap:8px; width:100%;">

        <!-- Prefix with its own label -->
        <div style="display:flex; flex-direction:column;">
          <label class="lable">
            {{ 'PROFILE.PREFIX' | translate }}
          </label>
          <dx-select-box
            [(ngModel)]="data.p.honorific"
            [items]="PrefixList"
            [displayExpr]="getTranslatedName"
            valueExpr="Ref"
            [searchEnabled]="true"
            placeholder="{{ 'PROFILE.PLACEHOLDERS.SELECT' | translate }}"
            class="inputfield"
            [showClearButton]="true"
            style="width:160px;">
          </dx-select-box>
        </div>

        <!-- Marathi First Name with its own label -->
        <div style="display:flex; flex-direction:column; flex:1;">
          <label class="lable">
            {{ 'PROFILE.FIRST_NAME_MR' | translate }}
          </label>
          <div class="input-with-loader">
            <dx-text-box
              [(ngModel)]="data.p.first_name_mr"
              stylingMode="outlined"
              class="inputfield"
              [placeholder]="'PROFILE.PLACEHOLDERS.FIRST_NAME_MR' | translate"
              (onFocusOut)="TranslateFirstNameToEnglish()">
            </dx-text-box>
            <div *ngIf="FirstNameEnloading" class="loader-overlay">
              <div class="loader"></div>
            </div>
          </div>
        </div>

      </div>
    </dxi-item>

    <!-- English Second -->
    <dxi-item [ratio]="6" class="separate-input-field">
      <label class="lable">
        {{ 'PROFILE.FIRST_NAME' | translate }}
      </label>
      <div class="input-with-loader">
        <dx-text-box
          [(ngModel)]="data.p.first_name"
          stylingMode="outlined"
          class="inputfield"
          [placeholder]="'PROFILE.PLACEHOLDERS.FIRST_NAME' | translate"
          (onFocusOut)="TranslateFirstNameToMarathi()"
          (onKeyUp)="capitalizeFirstLetter($event,'first_name')">
        </dx-text-box>
        <div *ngIf="FirstNameMrloading" class="loader-overlay">
          <div class="loader"></div>
        </div>
      </div>
    </dxi-item>

  </ng-container>

  <!-- English First Template -->
  <ng-template #englishFirstName>

    <!-- English First -->
    <dxi-item [ratio]="6" class="separate-input-field">

      <div style="display:flex; gap:8px; width:100%;">

        <!-- Prefix with its own label -->
        <div style="display:flex; flex-direction:column;">
          <label class="lable">
            {{ 'PROFILE.PREFIX' | translate }}
          </label>
          <dx-select-box
            [(ngModel)]="data.p.honorific"
            [items]="PrefixList"
            [displayExpr]="getTranslatedName"
            valueExpr="Ref"
            [searchEnabled]="true"
            placeholder="{{ 'PROFILE.PLACEHOLDERS.SELECT' | translate }}"
            class="inputfield"
            [showClearButton]="true"
            style="width:160px;">
          </dx-select-box>
        </div>

        <!-- English First Name with its own label -->
        <div style="display:flex; flex-direction:column; flex:1;">
          <label class="lable">
            {{ 'PROFILE.FIRST_NAME' | translate }}
          </label>
          <div class="input-with-loader">
            <dx-text-box
              [(ngModel)]="data.p.first_name"
              stylingMode="outlined"
              class="inputfield"
              [placeholder]="'PROFILE.PLACEHOLDERS.FIRST_NAME' | translate"
              (onFocusOut)="TranslateFirstNameToMarathi()"
              (onKeyUp)="capitalizeFirstLetter($event,'first_name')">
            </dx-text-box>
            <div *ngIf="FirstNameMrloading" class="loader-overlay">
              <div class="loader"></div>
            </div>
          </div>
        </div>

      </div>
    </dxi-item>

    <!-- Marathi Second -->
    <dxi-item [ratio]="6" class="separate-input-field">
      <label class="lable">
        {{ 'PROFILE.FIRST_NAME_MR' | translate }}
      </label>
      <div class="input-with-loader">
        <dx-text-box
          [(ngModel)]="data.p.first_name_mr"
          stylingMode="outlined"
          class="inputfield"
          [placeholder]="'PROFILE.PLACEHOLDERS.FIRST_NAME_MR' | translate"
          (onFocusOut)="TranslateFirstNameToEnglish()">
        </dx-text-box>
        <div *ngIf="FirstNameEnloading" class="loader-overlay">
          <div class="loader"></div>
        </div>
      </div>
    </dxi-item>

  </ng-template>

</dx-box>

  <!-- Row 2 : Middle Name + Middle Name Marathi -->
<dx-box direction="row" width="100%" [align]="'space-between'" [crossAlign]="'center'" style="margin-top: 0.5rem;">

  <ng-container *ngIf="isMarathi(); else englishMiddleName">

    <dxi-item [ratio]="6" class="separate-input-field">
      <label class="lable">{{ 'PROFILE.MIDDLE_NAME_MR' | translate }}</label>

      <div class="input-with-loader">
        <dx-text-box
          [(ngModel)]="data.p.middle_name_mr"
          class="inputfield"
          [placeholder]="'PROFILE.PLACEHOLDERS.MIDDLE_NAME_MR' | translate"
          (onFocusOut)="TranslateMiddleNameToEnglish()">
        </dx-text-box>

        <div *ngIf="MiddleNameMrloading" class="loader-overlay">
          <div class="loader"></div>
        </div>
      </div>
    </dxi-item>

    <dxi-item [ratio]="6" class="separate-input-field">
      <label class="lable">{{ 'PROFILE.MIDDLE_NAME' | translate }}</label>

      <div class="input-with-loader">
        <dx-text-box
          [(ngModel)]="data.p.middle_name"
          class="inputfield"
          [placeholder]="'PROFILE.PLACEHOLDERS.MIDDLE_NAME' | translate"
          (onFocusOut)="TranslateMiddleNameToMarathi()"
          (onKeyUp)="capitalizeFirstLetter($event,'middle_name')">
        </dx-text-box>

        <div *ngIf="MiddleNameEnloading" class="loader-overlay">
          <div class="loader"></div>
        </div>
      </div>
    </dxi-item>

  </ng-container>

  <ng-template #englishMiddleName>

    <dxi-item [ratio]="6" class="separate-input-field">
      <label class="lable">{{ 'PROFILE.MIDDLE_NAME' | translate }}</label>

      <div class="input-with-loader">
        <dx-text-box
          [(ngModel)]="data.p.middle_name"
          class="inputfield"
          [placeholder]="'PROFILE.PLACEHOLDERS.MIDDLE_NAME' | translate"
          (onFocusOut)="TranslateMiddleNameToMarathi()"
          (onKeyUp)="capitalizeFirstLetter($event,'middle_name')">
        </dx-text-box>

        <div *ngIf="MiddleNameEnloading" class="loader-overlay">
          <div class="loader"></div>
        </div>
      </div>
    </dxi-item>

    <dxi-item [ratio]="6" class="separate-input-field">
      <label class="lable">{{ 'PROFILE.MIDDLE_NAME_MR' | translate }}</label>

      <div class="input-with-loader">
        <dx-text-box
          [(ngModel)]="data.p.middle_name_mr"
          class="inputfield"
          [placeholder]="'PROFILE.PLACEHOLDERS.MIDDLE_NAME_MR' | translate"
          (onFocusOut)="TranslateMiddleNameToEnglish()">
        </dx-text-box>

        <div *ngIf="MiddleNameMrloading" class="loader-overlay">
          <div class="loader"></div>
        </div>
      </div>
    </dxi-item>

  </ng-template>

</dx-box>

  <!-- Row 3 : Last Name + Last Name Marathi -->
<dx-box direction="row" width="100%" [align]="'space-between'" [crossAlign]="'center'" style="margin-top: 0.5rem;">

  <ng-container *ngIf="isMarathi(); else englishLastName">

    <dxi-item [ratio]="6" class="separate-input-field">
      <label class="lable">{{ 'PROFILE.LAST_NAME_MR' | translate }}</label>

      <div class="input-with-loader">
        <dx-text-box
          [(ngModel)]="data.p.last_name_mr"
          class="inputfield"
          [placeholder]="'PROFILE.PLACEHOLDERS.LAST_NAME_MR' | translate"
          (onFocusOut)="TranslateLastNameToEnglish()">
        </dx-text-box>

        <div *ngIf="LstNameMrloading" class="loader-overlay">
          <div class="loader"></div>
        </div>
      </div>
    </dxi-item>

    <dxi-item [ratio]="6" class="separate-input-field">
      <label class="lable">{{ 'PROFILE.LAST_NAME' | translate }}</label>

      <div class="input-with-loader">
        <dx-text-box
          [(ngModel)]="data.p.last_name"
          class="inputfield"
          [placeholder]="'PROFILE.PLACEHOLDERS.LAST_NAME' | translate"
          (onFocusOut)="TranslateLastNameToMarathi()"
          (onKeyUp)="capitalizeFirstLetter($event,'last_name')">
        </dx-text-box>

        <div *ngIf="LstNameEnloading" class="loader-overlay">
          <div class="loader"></div>
        </div>
      </div>
    </dxi-item>

  </ng-container>

  <ng-template #englishLastName>

    <dxi-item [ratio]="6" class="separate-input-field">
      <label class="lable">{{ 'PROFILE.LAST_NAME' | translate }}</label>

      <div class="input-with-loader">
        <dx-text-box
          [(ngModel)]="data.p.last_name"
          class="inputfield"
          [placeholder]="'PROFILE.PLACEHOLDERS.LAST_NAME' | translate"
          (onFocusOut)="TranslateLastNameToMarathi()"
          (onKeyUp)="capitalizeFirstLetter($event,'last_name')">
        </dx-text-box>

        <div *ngIf="LstNameEnloading" class="loader-overlay">
          <div class="loader"></div>
        </div>
      </div>
    </dxi-item>

    <dxi-item [ratio]="6" class="separate-input-field">
      <label class="lable">{{ 'PROFILE.LAST_NAME_MR' | translate }}</label>

      <div class="input-with-loader">
        <dx-text-box
          [(ngModel)]="data.p.last_name_mr"
          class="inputfield"
          [placeholder]="'PROFILE.PLACEHOLDERS.LAST_NAME_MR' | translate"
          (onFocusOut)="TranslateLastNameToEnglish()">
        </dx-text-box>

        <div *ngIf="LstNameMrloading" class="loader-overlay">
          <div class="loader"></div>
        </div>
      </div>
    </dxi-item>

  </ng-template>

</dx-box>

  <!-- Row 4 : Mobile No + Email -->
  <dx-box
    direction="row"
    width="100%"
    [align]="'space-between'"
    [crossAlign]="'center'"
    style="margin-top: 0.5rem;">

    <dxi-item [ratio]="6" class="separate-input-field">
      <label class="lable">
        {{ 'PROFILE.MOBILE_NO' | translate }}
      </label>

      <dx-text-box
        [(ngModel)]="data.p.mobile_no"
        stylingMode="outlined"
        class="inputfield"
        [placeholder]="'PROFILE.PLACEHOLDERS.MOBILE_NO' | translate">
      </dx-text-box>
    </dxi-item>

    <dxi-item [ratio]="6" class="separate-input-field">
      <label class="lable">
        {{ 'PROFILE.EMAIL' | translate }}
      </label>

      <dx-text-box
        [(ngModel)]="data.p.email_id"
        stylingMode="outlined"
        class="inputfield"
        [placeholder]="'PROFILE.PLACEHOLDERS.EMAIL' | translate"
        [disabled]="true">
      </dx-text-box>
    </dxi-item>

  </dx-box>

  <dx-box direction="row" width="100%" [align]="'space-between'" [crossAlign]="'center'" style="margin-top: 0.5rem;">

    <dxi-item [ratio]="6" class="separate-input-field">
      <label class="lable">
        {{ 'PROFILE.AF' | translate }}
      </label>

      <dx-text-box [(ngModel)]="data.p.under_supervision_name" stylingMode="outlined" class="inputfield"
        [placeholder]="'PROFILE.PLACEHOLDERS.AF' | translate" [disabled]="true">
      </dx-text-box>
    </dxi-item>
  </dx-box>

</div>

<!-- Save Button -->
<div
  class="button-section"
  [align]="'center'"
  style="margin-top: 1rem; margin-bottom: 2rem;">

  <app-cancelbutton
    [text]="'PROFILE.CANCEL' | translate"
    (clicked)="backToDashboard()">
  </app-cancelbutton>

  <dx-button
    [elementAttr]="{ class: 'save-button' }"
    [disabled]="isSaveDisabled"
    [text]="'PROFILE.UPDATE' | translate"
    type="default"
    stylingMode="contained"
    (click)="SaveProfile()">
  </dx-button>
</div>